var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import SelectObjectStore from "@/components/ObjectStore/SelectObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolSelectPreferredObjectStore',
    props: {
        toolPreferredObjectStoreId: { default: null }
    },
    emits: ["updated"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedObjectStoreId = ref(props.toolPreferredObjectStoreId);
        const newDatasetsDescription = "The default storage location for the outputs of this tool";
        const defaultOptionTitle = "Use Defaults";
        const defaultOptionDescription = "If the history has a default set, that will be used. If instead, you've set an option in your user preferences - that will be assumed to be your default selection. Finally, the Galaxy configuration will be used.";
        function handleSubmit(preferredObjectStoreId) {
            return __awaiter(this, void 0, void 0, function* () {
                selectedObjectStoreId.value = preferredObjectStoreId;
                emit("updated", preferredObjectStoreId);
            });
        }
        return { __sfc: true, props, selectedObjectStoreId, newDatasetsDescription, defaultOptionTitle, defaultOptionDescription, emit, handleSubmit, SelectObjectStore };
    }
});
